import { getRouteApi } from '@tanstack/react-router';

const areaLandingRoute = getRouteApi('/_layout/view/$areaSlug/');
const viewerRoute = getRouteApi('/_layout/view/$areaSlug/$viewerType/$subjectSlug');

export const useAreaLandingParams = () => areaLandingRoute.useParams();
export const useViewerRouteParams = () => viewerRoute.useParams();
export const useViewerSearchParams = () => viewerRoute.useSearch();
